import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { AggregatePeriod } from 'v2/core/entities';

interface TimePeriodProps {
  value: AggregatePeriod;
  onChange: (value: AggregatePeriod) => void;
  disable?: {
    [AggregatePeriod.DAY]?: boolean;
    [AggregatePeriod.WEEK]?: boolean;
    [AggregatePeriod.MONTH]?: boolean;
  };
}

export function TimePeriod({ value, onChange, disable = {} }: TimePeriodProps) {
  const renderChip = (
    aggregatePeriod:
      | AggregatePeriod.DAY
      | AggregatePeriod.WEEK
      | AggregatePeriod.MONTH,
    label: string,
  ) => {
    return (
      <Tooltip
        arrow
        placement="top"
        title={
          disable[aggregatePeriod]
            ? `The query duration is too small or large for ${label} analysis`
            : ''
        }
      >
        <Box>
          <Chip
            label={label}
            variant="outlined"
            size="small"
            sx={{ minWidth: 80 }}
            color={value === aggregatePeriod ? 'primary' : 'default'}
            onClick={() => onChange(aggregatePeriod)}
            disabled={disable[aggregatePeriod]}
          />
        </Box>
      </Tooltip>
    );
  };

  return (
    <Stack direction="row" spacing={1}>
      {renderChip(AggregatePeriod.DAY, 'Daily')}
      {renderChip(AggregatePeriod.WEEK, 'Weekly')}
      {renderChip(AggregatePeriod.MONTH, 'Monthly')}
    </Stack>
  );
}
